module.exports = __webpack_public_path__ + "static/img/homepage-header-Clix.b29e08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/homepage-header-Clix.png
// module id = X7l/
// module chunks = 38